import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import { RouteLocationRaw } from 'vue-router';
import { Banner } from '@components/Banner';
import { FLEET as FLEET_LABELS } from '@shell/config/labels-annotations';
import { FLEET } from '@shell/config/types';
import { NAME as FLEET_NAME } from '@shell/config/product/fleet';
import { FLEET as FLEET_FEATURE } from '@shell/store/features';
import { BLANK_CLUSTER } from '@shell/store/store-types';


export default /*@__PURE__*/_defineComponent({
  __name: 'FleetManagedBanner',
  props: {
    resource: {}
  },
  setup(__props: any) {

const SOURCE_TYPES: Record<string, string> = {
  gitrepo: FLEET.GIT_REPO,
  helmop:  FLEET.HELM_OP,
  bundle:  FLEET.BUNDLE,
};

const props = __props;

const store = useStore();

const productName = computed(() => store.getters['i18n/t'](`product.${ FLEET_NAME }`));

const labels = computed(() => props.resource?.metadata?.labels || {});

const isFleetManaged = computed(() => !!labels.value[FLEET_LABELS.MANAGED_BY_KIND]);

const canList = (type: string): boolean => !!store.getters['management/canList'](type);

const canSeeWorkspace = (workspace: string): boolean => canList(FLEET.WORKSPACE) &&
  store.getters['management/all'](FLEET.WORKSPACE).some((ws: { id: string }) => ws.id === workspace);

const sourceLocation = computed<RouteLocationRaw | undefined>(() => {
  const kind = labels.value[FLEET_LABELS.MANAGED_BY_KIND];
  const namespace = labels.value[FLEET_LABELS.MANAGED_BY_NAMESPACE];
  const id = labels.value[FLEET_LABELS.MANAGED_BY_NAME];
  const resource = SOURCE_TYPES[kind];

  if (
    !resource || !namespace || !id ||
    !store.getters['features/get'](FLEET_FEATURE) ||
    !canList(resource) ||
    !canSeeWorkspace(namespace)
  ) {
    return undefined;
  }

  if (kind === 'bundle') {
    return {
      name:   'c-cluster-product-resource-namespace-id',
      params: {
        cluster: BLANK_CLUSTER, product: FLEET_NAME, resource, namespace, id
      }
    };
  }

  return {
    name:   'c-cluster-fleet-application-resource-namespace-id',
    params: {
      cluster: BLANK_CLUSTER, resource, namespace, id
    }
  };
});

return (_ctx: any,_cache: any) => {
  const _component_t = _resolveComponent("t")!
  const _component_router_link = _resolveComponent("router-link")!

  return (isFleetManaged.value)
    ? (_openBlock(), _createBlock(_unref(Banner), {
        key: 0,
        color: "info",
        "data-testid": "fleet-managed-banner"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, [
            _createVNode(_component_t, {
              k: "resourceDetail.masthead.fleetManaged",
              raw: true,
              name: productName.value
            }, null, 8, ["name"]),
            _cache[1] || (_cache[1] = _createTextVNode()),
            (sourceLocation.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[0] || (_cache[0] = _createTextVNode(_toDisplayString(' ') + " ", -1)),
                  _createVNode(_component_router_link, {
                    to: sourceLocation.value,
                    class: "secondary text-no-break",
                    "data-testid": "fleet-managed-banner-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('resourceDetail.masthead.fleetManagedLink', { name: productName.value })), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})